@import 'core';


/**
 * CSS Variables for Advanced Background Component
 * 
 * @prop --ads-advanced-background-padding-top: Padding Top - value in pixel (default: 90px)
 * @prop --ads-advanced-background-padding-bottom: Padding Bottom - value in pixel (default: 45px)
 * @prop --ads-advanced-background-color: Background Colour (default: #fff)
 * @prop --ads-advanced-background-gradient-type: Background Colour Gradient Type (Leftright, Topdown)
 * @prop --ads-advanced-background-gradient-start-color: Background Gradient Start Colour - Hex code No.% ( #000 50% )
 * @prop --ads-advanced-background-gradient-end-color: Background Gradient End Colour - Hex code No.% ( #000 50% )
 * @prop --ads-advanced-background-attachment: Background attachment (scroll, fixed, local)
 * @prop --ads-advanced-background-blend-mode: Background blend mode (normal, multiply, hard-light, difference)
 * @prop --ads-advanced-background-repeat: Background repeat (repeat-x, repeat, space, round, no-repeat)
 * @prop --ads-advanced-background-size: Background size (contain, cover)
 * @prop --ads-advanced-background-position: Background Position (top, left, center)
 * @prop --ads-advanced-background-mix-blend-mode: Mix Blend Mode (normal, multiply, hard-light, difference)
 * @prop --ads-advanced-background-content-above-video-top-pos: Content Above Video Top Position - value in pixel (default: 2100px)
 * @prop --ads-advanced-background-video-container-video-controls-width: Video controls width - value in pixel (default: 200px)
 * @prop --ads-advanced-background-video-container-video-controls-height: Video controls height - value in pixel (default: 200px)
 * @prop --ads-advanced-background-image-overlay-opacity: Image overlay opacity (default: 0.7)
 * @prop --ads-advanced-background-image-overlay-blend-mode: Image overlay blend mode (default: overlay)
 * @prop --ads-advanced-background-gradient-overlay-opacity: Gradient overlay opacity (default: 1)
 * @prop --ads-advanced-background-video-image-min-height: Video Image minimum height (default: 100vh)
 * @prop --ads-advanced-background-video-image-content-justify: Video Image content justify (default: center)
 * @prop --ads-advanced-background-video-image-content-align: Video Image content align (default: center)
 * @prop --ads-advanced-background-video-opacity: Video opacity (default: 0.8)
 */

/**
 * CSS Styles for Advanced Background Component
 */

.advanced-background {
  position: relative;
  padding-top: var(--ads-advanced-background-padding-top, #{$ads-advanced-background-padding-top});
  padding-bottom: var(--ads-advanced-background-padding-bottom, #{$ads-advanced-background-padding-bottom});
  background: var(--ads-advanced-background-color, #{$ads-advanced-background-color});
  background-attachment: var(--ads-advanced-background-attachment, #{$ads-advanced-background-attachment});
  background-blend-mode: var(--ads-advanced-background-blend-mode, #{$ads-advanced-background-blend-mode});
  background-repeat: var(--ads-advanced-background-repeat, #{$ads-advanced-background-repeat});
  background-size: var(--ads-advanced-background-size, #{$ads-advanced-background-size});
  background-position: var(--ads-advanced-background-position, #{$ads-advanced-background-position});
  overflow-x: hidden;

  .content-container {
    mix-blend-mode: var(--ads-advanced-background-mix-blend-mode, #{$ads-advanced-background-mix-blend-mode});
  }

  &.image-gradient {
    .gradient-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        var(--ads-advanced-background-gradient-type, #{$ads-advanced-background-gradient-type}),
        var(--ads-advanced-background-gradient-start-color, #{$ads-advanced-background-gradient-start-color}),
        var(--ads-advanced-background-gradient-end-color,#{$ads-advanced-background-gradient-end-color})
      );
      z-index: 1;
      opacity: var(--ads-advanced-background-gradient-overlay-opacity, #{$ads-advanced-background-gradient-overlay-opacity});
    }

    .image-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-attachment: var(--ads-advanced-background-attachment, #{$ads-advanced-background-attachment});
      background-blend-mode: var(--ads-advanced-background-blend-mode, #{$ads-advanced-background-blend-mode});
      background-repeat: var(--ads-advanced-background-repeat, #{$ads-advanced-background-repeat});
      background-size: var(--ads-advanced-background-size, #{$ads-advanced-background-size});
      background-position: var(--ads-advanced-background-position, #{$ads-advanced-background-position});
      z-index: 2;
      opacity: var(--ads-advanced-background-image-overlay-opacity, #{$ads-advanced-background-image-overlay-opacity});
      mix-blend-mode: var(--ads-advanced-background-image-overlay-blend-mode, #{$ads-advanced-background-image-overlay-blend-mode});
    }

    .content-container {
      position: relative;
      z-index: 3;
      background: transparent;
    }

    &.parallax {
      .image-overlay {
        background-attachment: fixed;
      }
    }
  }

  &.video-image {
    min-height: var(--ads-advanced-background-video-image-min-height, #{$ads-advanced-background-video-image-min-height});
    display: flex;
    flex-direction: column;

    .video-image-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      overflow: hidden;

      .background-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-attachment: var(--ads-advanced-background-attachment, #{$ads-advanced-background-attachment});
        background-blend-mode: var(--ads-advanced-background-blend-mode, #{$ads-advanced-background-blend-mode});
        background-repeat: var(--ads-advanced-background-repeat, #{$ads-advanced-background-repeat});
        background-size: var(--ads-advanced-background-size, #{$ads-advanced-background-size});
        background-position: var(--ads-advanced-background-position, #{$ads-advanced-background-position});
      }

      .bg-video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        opacity: var(--ads-advanced-background-video-opacity, #{$ads-advanced-background-video-opacity});
      }

      .parallax-video {
        position: fixed;
        top: 50%;
        left: 50%;
        min-width: 100%;
        min-height: 100%;
        transform: translate(-50%, -50%) translateZ(-1px) scale(2);
        z-index: 1;
        object-fit: cover;
        opacity: var(--ads-advanced-background-video-opacity, #{$ads-advanced-background-video-opacity});
      }
    }

    .content-container {
      position: relative;
      z-index: 2;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: var(--ads-advanced-background-video-image-content-justify, #{$ads-advanced-background-video-image-content-justify});
      align-items: var(--ads-advanced-background-video-image-content-align, #{$ads-advanced-background-video-image-content-align});
    }
  }

  &.parallax:not(.video-parallax) {
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }


  &.video-parallax {
    height: 100vh;
    overflow-y: auto;
    perspective: 1px;
    transform-style: preserve-3d;
  }

  .content-container {
    position: relative;
    z-index: 2;

    &.parallax-content {
      transform: translateZ(0);
      z-index: 3;
      pointer-events: auto;
    }
  }

  &.gradient {
    background: linear-gradient(
      var(--ads-advanced-background-gradient-type, #{$ads-advanced-background-gradient-type}),
      var(--ads-advanced-background-gradient-start-color, #{$ads-advanced-background-gradient-start-color}),
      var(--ads-advanced-background-gradient-end-color,#{$ads-advanced-background-gradient-end-color})
    );
  }
}

.video-container {
  position: relative;

  
  .bg-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
  }

  .parallax-video {
    position: fixed;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    transform: translate(-50%, -50%) translateZ(-1px) scale(2);
    z-index: 1;
    object-fit: cover;
  }

  .video-controls {
    position: fixed;
    bottom: 10px;
    right: 20px;
    left: auto;
    top: auto;
    width: var(--ads-advanced-background-video-container-video-controls-width,#{$ads-advanced-background-video-container-video-controls-width});
    height: var(--ads-advanced-background-video-container-video-controls-height,#{ads-advanced-background-video-container-video-controls-height});
    display: flex;
    justify-content: flex-end;
    z-index: 4;
    padding: 8px 12px;
    border-radius: 25px;
    backdrop-filter: blur(2px);


    #ctrlBtn {
      width: 32px;
      font-size: 18px;
      border: none;
      cursor: pointer;
      
      &:hover {
        transform: scale(1.1);
        color: var(--ads-advanced-background-color, #fff);
      }
      
      svg {
        width: 24px;
        height: 24px;
      }
    }

    &.inverted {
      filter: invert(1);
      background: rgba(255, 255, 255, 0.5);
    }
  }
}
